import axios from 'axios'
import React, { useEffect, useState } from 'react'
import apiClient from '../../../utils/apiclient'
import { useNavigate } from 'react-router-dom'

const hasSubscriptionAddOnMappings = (mappings) => {
  if (Array.isArray(mappings)) {
    return mappings.length > 0
  }

  if (mappings && typeof mappings === 'object') {
    return Object.keys(mappings).length > 0
  }

  return typeof mappings === 'string' && mappings.trim().length > 0
}

const parseSubscriptionAddOnMappings = (mappings) => {
  if (Array.isArray(mappings)) {
    return mappings
  }

  if (mappings && typeof mappings === 'object') {
    return [mappings]
  }

  if (typeof mappings === 'string' && mappings.trim()) {
    try {
      const parsedMappings = JSON.parse(mappings)
      if (Array.isArray(parsedMappings)) {
        return parsedMappings
      }
      return parsedMappings && typeof parsedMappings === 'object'
        ? [parsedMappings]
        : []
    } catch (error) {
      console.error('Unable to parse subscription add-on mappings:', error)
    }
  }

  return []
}

const CompletedSubscriptiOnorders = (route) => {
  const navigate = useNavigate()
 const [search,Setsearch]=useState("")
const [data, Setdata] = useState([]);
const [page, setPage] = useState(0);
const [size] = useState(20);
const [totalPages, setTotalPages] = useState(0);
const [loading, setLoading] = useState(false);
const [freebieMap, setFreebieMap] = useState({});
const [expandedAddOnMappings, setExpandedAddOnMappings] = useState({});
useEffect(() => {
  fetchOrders();
}, [page,search]);

const fetchOrders = async () => {
  try {
    setLoading(true);

    const response = await apiClient.get(
      `${route.route}?page=${page}&size=${size}&search=${search}`
    );

    Setdata(response.data.content);
    setTotalPages(response.data.totalPages);

    const freebieStateMap = {};
    response.data.content.forEach((order) => {
      freebieStateMap[order.id] = order.freebieDelivered ?? false;
    });
    setFreebieMap(freebieStateMap);

  } catch (e) {
    console.error(e);
  } finally {
    setLoading(false);
  }
};
const filteredData = Array.isArray(data)
  ? data.filter((el) => {
      if (search.trim() === "") return true;

      return (
        el.number?.toString().includes(search) ||
        el.userdetails?.name
          ?.toLowerCase()
          .includes(search.toLowerCase())||
                el.email?.toLowerCase().includes(search.toLowerCase())

      );
    })
  : [];

const handleFreebieChange = (orderId, value) => {
  setFreebieMap((prev) => ({
    ...prev,
    [orderId]: value === 'true',
  }));
};

const handleSaveFreebie = async (orderId) => {
  const newStatus = freebieMap[orderId] ?? false;

  try {
    await apiClient.post('/update-freebieDelivered', {
      orderType: 'S',
      id: orderId,
      status: newStatus,
    });

    Setdata((prev) =>
      prev.map((order) =>
        order.id === orderId
          ? { ...order, freebieDelivered: newStatus }
          : order
      )
    );
  } catch (e) {
    console.error(e);
  }
};

const toggleAddOnMappings = (orderId) => {
  setExpandedAddOnMappings((prev) => ({
    ...prev,
    [orderId]: !prev[orderId],
  }));
};

// const filteredData = data.filter((el) => {
//     if (search.trim() === "") {
//       return true; 
//     }
//     return (
//       el.name?.toLowerCase().includes(search.toLowerCase()) || 
//       el.number?.toString().includes(search) ||
//       el.email?.toLowerCase().includes(search.toLowerCase())
//     );
//   });
    const handlechange=(e)=>{
        const value=e.target.value;
        Setsearch(value);
        console.log(value)
    }
  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Completed Subscription Orders</h2>
        <input className="flex-1 border-2 py-1.5 px-3 md:py-2 md:px-4 text-sm md:text-base rounded-lg outline-none focus:border-blue-500 min-w-0"
          placeholder='Search...'
          onChange={handlechange}
          value={search}
        />
      </div>

    <div className="w-full flex-1 flex flex-col min-h-0">
    {loading ? (
<div className="absolute inset-0 bg-white/60 flex justify-center items-center z-10">
      Loading...
    </div>
) : (
    <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
      <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
      <tr>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">
          SubscriptionOrder Id
        </th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">
          Add-on Mappings
        </th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Public Id</th>

        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm" >Customer Number</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm" >Customer Name</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">meal name</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">subscription Order Instruction</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">OTP</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Restaurant name</th>

        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">orderStatus</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Freebie Delivered</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">start time</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">end time</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">order Date</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Start Time</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">End Time</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Subscription Price</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Meal Plan</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">City</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Street</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Latitude</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Longitude</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Rider name</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Rider number</th>
<th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Created At</th>
          <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm whitespace-nowrap">Updated At</th>

      </tr>
      </thead><tbody>
        {
          data.map((data,index)=>{
            const addOnMappings = data.subscriptionAddOnMappings;
            const hasAddOnMappings = hasSubscriptionAddOnMappings(addOnMappings);
            const parsedAddOnMappings = parseSubscriptionAddOnMappings(addOnMappings);
            const areAddOnMappingsExpanded = Boolean(expandedAddOnMappings[data.id]);

            return (
            <React.Fragment key={data.id ?? index}>
            <tr className='items-center justify-center border border-gray-300'>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
                {data.id}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">
                <button
                  type="button"
                  aria-expanded={areAddOnMappingsExpanded}
                  aria-controls={`completed-subscription-add-on-mappings-${data.id}`}
                  onClick={() => toggleAddOnMappings(data.id)}
                  className={`px-2 py-1 rounded text-white text-[10px] md:text-xs font-medium ${
                    hasAddOnMappings
                      ? 'bg-green-600 hover:bg-green-700'
                      : 'bg-red-600 hover:bg-red-700'
                  }`}
                >
                  {areAddOnMappingsExpanded ? 'Hide add-ons' : 'View add-ons'}
                </button>
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.publicId}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline" onClick={()=>{navigate(`/userDetails/${data.number}`)}}>{data.number}</td>
                      <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.userdetails?.name}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealName}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.subscriptionOrderInstruction?data.subscriptionOrderInstruction:"no data"}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.otp}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline"onClick={()=>{navigate(`/restaurant/${data.restaurantid}`)}} >{data.restaurantName}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.status}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
                <div className="flex items-center justify-center gap-2">
                  <select
                    className="border rounded px-2 py-1"
                    value={String(freebieMap[data.id] ?? false)}
                    onChange={(e) => handleFreebieChange(data.id, e.target.value)}
                  >
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                  </select>

                  {String(freebieMap[data.id] ?? false) !== String(data.freebieDelivered ?? false) && (
                    <button
                      onClick={() => handleSaveFreebie(data.id)}
                      className="bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-1 rounded text-sm font-medium"
                    >
                      Save Freebie
                    </button>
                  )}
                </div>
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.startTime}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.endTime}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.orderdate}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.startTime}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.endTime}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplanprice}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplanname}</td>
                      <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.city}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.street}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.latitude}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.longitude}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.riderDetails.name}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.riderDetails.number}</td>
                  <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.createdAt?data.createdAt.split("T")[1].split(".")[0]:"-"}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center whitespace-nowrap">{data.updatedAt?data.updatedAt.split("T")[1].split(".")[0]:"-"}</td>
            </tr>
            {areAddOnMappingsExpanded && (
              <tr
                id={`completed-subscription-add-on-mappings-${data.id}`}
                className="border border-gray-300 bg-gray-50"
              >
                <td colSpan={26} className="px-4 py-3">
            <div className="text-left">
              <h3 className="mb-2 text-xs md:text-sm font-semibold text-gray-800">
                Subscription add-on mappings for order {data.id}
              </h3>
              {parsedAddOnMappings.length > 0 ? (
                <div className="overflow-auto">
                  <table className="min-w-max w-full border-collapse bg-white text-[10px] md:text-xs">
                    <thead className="bg-gray-800 text-white">
                      <tr>
                        <th className="border px-2 py-2">Id</th>
                        <th className="border px-2 py-2">Item Mapping Id</th>
                        <th className="border px-2 py-2">Item Id</th>
                        <th className="border px-2 py-2">Name</th>
                        <th className="border px-2 py-2">Price</th>
                        <th className="border px-2 py-2">Description</th>
                        <th className="border px-2 py-2">Public Lunch Description</th>
                        <th className="border px-2 py-2">Public Dinner Description</th>
                        <th className="border px-2 py-2">Count</th>
                        <th className="border px-2 py-2">Mapping Price</th>
                        <th className="border px-2 py-2">Status</th>
                        <th className="border px-2 py-2">Razorpay Order Id</th>
                        <th className="border px-2 py-2">Razorpay Payment Id</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parsedAddOnMappings.flatMap((mapping, mappingIndex) => {
                        const items = Array.isArray(mapping.items) ? mapping.items : []
                        const rows = items.length > 0 ? items : [null]

                        return rows.map((entry, itemIndex) => (
                          <tr
                            key={`${mapping.id ?? mappingIndex}-${entry?.id ?? itemIndex}`}
                            className="border"
                          >
                            <td className="border px-2 py-2 text-center">{mapping.id ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{entry?.id ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{entry?.item?.id ?? '-'}</td>
                            <td className="border px-2 py-2">{entry?.item?.name ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{entry?.item?.price ?? '-'}</td>
                            <td className="border px-2 py-2">{entry?.item?.description ?? '-'}</td>
                            <td className="border px-2 py-2">{entry?.item?.publiclunchDescription ?? '-'}</td>
                            <td className="border px-2 py-2">{entry?.item?.publicdinnerDescription ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{entry?.count ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{mapping.price ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{mapping.status ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{mapping.razorpayOrderId ?? '-'}</td>
                            <td className="border px-2 py-2 text-center">{mapping.razorpayPaymentId ?? '-'}</td>
                          </tr>
                        ))
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-[10px] md:text-xs text-gray-600">
                  No add-on mappings for this order.
                </p>
              )}
            </div>
                </td>
              </tr>
            )}
            </React.Fragment>
            )
          })
        }</tbody>
     </table>
      </div> )}

 </div>
     <div className="flex justify-center items-center gap-4 mt-0 pb-4 flex-shrink-0">
        <button
          disabled={page === 0 || loading}
          onClick={() => setPage((prev) => prev - 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Previous
        </button>

        <span className="font-medium text-gray-700">
          Page {page + 1} of {totalPages}
        </span>

        <button
          disabled={page >= totalPages - 1 || loading}
          onClick={() => setPage((prev) => prev + 1)}
          className="px-6 py-2 bg-gray-800 text-white font-semibold rounded disabled:opacity-50 hover:bg-gray-700 transition-colors"
        >
          Next
        </button>
      </div>
     </div>
  )
}

export default CompletedSubscriptiOnorders